import { OrderState } from './checkoutState';

const getCarriers = (orderState: OrderState) =>
  Array.from(new Set(orderState.basket.packages.map(pkg => pkg.carrierGroupKey)));

export default getCarriers;
